import React from 'react';

const ArrowDownSorting: React.FC<React.PropsWithChildren> = () => (
  <svg width="20" height="20" viewBox="0 0 28 28" fill="#FFF">
    <path d="M19 15L17.59 13.59L13 18.17V2H11V18.17L6.41 13.58L5 15L12 22L19 15Z" fill="white" />
  </svg>
);

export default ArrowDownSorting;
